/* eslint-disable */
import {API} from '../api'
import {acaoApi} from '../helpers/enums'

export const lista = (url) => {
  return API.get(url)
}

export const pegaLista= (url, data) => {
  return API.get(url, { params: {data: data} })
}

export const processar = (url, objeto, acao) => {
  if (acao === acaoApi.GRAVAR) {
    return API.post(url, objeto)
  } else if (acao === acaoApi.REMOVER) {
    return API.delete(url, {data: objeto})
  }
}

export const pega = (url, id) => {
  return API.get(url + '/' + id)
}

export const pegaDados = (url, data) => {
  return API.post(url, data)
}


export const listaByGrupo = (url, id) => {
  return API.post(url, {grupo_id: id})
}

export const listaBySubgrupo = (url, id) => {
  return API.post(url, {subgrupo_id: id})
}

export const autentica = (url, objeto) => {
  return API.post(url, objeto)
}


export const pegar = (url, item) => {
  return API.get(url, { params: item })
}
